import React, { useRef, useState } from 'react'
import { Flex, message, Spin, Button, Typography } from 'antd'
import { UploadOutlined, FileOutlined } from '@ant-design/icons'

import { awsStorage } from '../../services/aws'

import Config from 'src/config/app'

const { Text } = Typography

interface IProps {
  onFileUpload: (url: string) => void
}

const FileUpload: React.FC<IProps> = ({ onFileUpload }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [loading, setLoading] = useState(false)
  const [fileUrl, setFileUrl] = useState<string | null>(null)
  const [uploadTime, setUploadTime] = useState<number | null>(null)

  const handleClick = () => {
    inputRef.current?.click()
  }

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    setLoading(true)
    setUploadTime(null)
    const start = Date.now()

    const domain = Config.services.awss3.buckets.requirementsDomain
    const bucket = Config.services.awss3.buckets.requirements
    const timestamp = Date.now()
    const extension = file.name.split('.').pop()
    const filename = `file-${timestamp}.${extension}`
    const path = `whatsapp/${filename}`

    try {
      await awsStorage(
        bucket,
        path,
        file,
        ({ percent }: { percent: number }) => {
          console.log(`Progreso: ${percent}%`)
        },
        () => {
          setLoading(false)
          message.error('❌ Error al subir el archivo')
        },
        () => {
          const url = `${domain}/${path}`
          setLoading(false)
          setUploadTime(Date.now() - start)
          setFileUrl(url)
          message.success('✅ Archivo subido con éxito')
          onFileUpload(url)
        }
      )
    } catch (err) {
      setLoading(false)
      console.error('Error subiendo a S3:', err)
      message.error('🚫 Fallo inesperado al subir archivo')
    }
  }

  return (
    <div>
      <input
        type="file"
        // accept=".csv,.xlsx,.xls,.pdf"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleFileUpload}
      />

      <Flex
        gap={4}
        justify="center"
        align="center"
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        {loading ? (
          <Spin size="small" />
        ) : (
          <>
            <UploadOutlined style={{ fontSize: 14, color: 'white' }} />
            <span style={{ fontSize: 12, color: 'white' }}>
              {fileUrl ? 'Cambiar archivo' : 'Adjuntar lista (Opcional)'}
            </span>
          </>
        )}
      </Flex>

      {fileUrl && (
        <Flex vertical justify="center" align="center" style={{ marginTop: 2 }}>
          <Button
            type="link"
            icon={<FileOutlined />}
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            style={{ fontSize: 10 }}
          >
            Ver archivo cargado
          </Button>
          {/*uploadTime !== null && (
            <Text type="secondary">Tiempo de carga: {(uploadTime / 1000).toFixed(2)} segundos</Text>
          )*/}
        </Flex>
      )}
    </div>
  )
}

export default FileUpload
